<template>

  <div class="mycontainer">
   <iframe id="qianru" name="qianru"  class="iframeclass" :src="iframesrc" frameborder="0" scrolling="no"></iframe>
  </div>

</template>

<script>

  export default {
    name: "role-management",
    data(){
      return{
        iframesrc:'',
        startPage:Number(this.$route.params.startPage),//当前页数

      }
    },
    watch:{
    },
    mounted(){
      var timestamp = Date.now() + Math.floor(Math.random() * 100000);
      this.iframesrc=BASE.base3+'/#/authorityManagement/roleManagement/1'+'?timestamp='+timestamp;

      const oIframe = document.getElementById('qianru')
      oIframe.contentWindow.name = LocalStorage.get('datacollect_token')

    },
    methods:{

    }
  }
</script>

<style lang="less" type="text/less" rel="stylesheet/less" scoped>
  .mycontainer{
    /*background: #fff;*/
    width: 100%;
    min-height: calc(100vh - 70px);
    .iframeclass{
      width: 100%;
      min-height: 850px;
    }

  }

</style>



// WEBPACK FOOTER //
// src/views/authorityManagement/roleManagement.vue